<script lang="ts" setup>
defineProps<{
  slideable?: true
}>()
</script>

<template>
  <div
    class="container max-w-md px-6 lg:px-16 lg:mx-auto lg:max-w-screen-lg xl:max-w-screen-lg"
    :class="{ '<lg:overflow-x-scroll': slideable }"
  >
    <div v-if="slideable" class="<lg:min-w-full <lg:float-left">
      <slot/>
    </div>
    <template v-else>
      <slot/>
    </template>
  </div>
</template>
